import * as React from "react";
import {Card, CardBody, CardHeader, CardImage, CardSubtitle, CardTitle,
  TabStrip, TabStripSelectEventArguments, TabStripTab,
} from "@progress/kendo-react-layout";
import "./LoginContainer.scss";
import { LoginSteps } from "./steps/LoginSteps";
import { RegisterSteps } from "./steps/RegisterSteps";
import { PasswordResetSteps } from "./steps/PasswordResetSteps";
import {useCallback, useEffect} from "react";


interface IUserProps {
  dialogToggle: () => void;
  tabSelect: any;
  resetPassword?: boolean;
  passwordHasBeenSet: () => void;
  activateAccount?: boolean;
}

const AuthTabs = (props: IUserProps) => {
  const [selected, setSelected] = React.useState<number>(0);
  const [isPasswordStep, setPasswordStep] = React.useState<boolean>(props.resetPassword!);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const passwordHasBeenSet = useCallback(() => {
    setPasswordStep(false);
    passwordHasBeenSet();
    },[],);

  // TODO is this needed
  useEffect(() => {
    setSelected(props.tabSelect);
  }, [props.tabSelect]);

  return (
    <div className="modal-content" style={{ background: "lightsteelblue" }}>
      {/*<GridLayout*/}
      {/*  rows={[{ height: "3em" }, { height: "auto" }, { height: "3em" }]}*/}
      {/*  cols={[{ width: "5%" }, { width: "auto" }, { width: "5%" }]}*/}
      {/*>*/}
      {/*  <GridLayoutItem col={2} row={2} className="form-container">*/}
          <Card className="card-container">
            <div>
              <CardHeader>
                <CardTitle style={{ textAlign: "center" }}>
                  <strong>Rules & Regulations Subscription Service</strong>
                </CardTitle>
                <CardSubtitle></CardSubtitle>
              </CardHeader>

              <CardBody>
                <div>
                  <TabStrip selected={selected} onSelect={handleSelect}>

                    <TabStripTab title="Login">
                      <LoginSteps activateAccount={props.activateAccount}/>
                    </TabStripTab>

                    <TabStripTab title="Reset Password">
                      <PasswordResetSteps passwordStep={isPasswordStep} passwordSet={passwordHasBeenSet}/>
                    </TabStripTab>

                    <TabStripTab title="Register">
                      <RegisterSteps/>
                    </TabStripTab>

                  </TabStrip>
                </div>
              </CardBody>
            </div>
          </Card>
      {/*  </GridLayoutItem>*/}
      {/*</GridLayout>*/}
    </div>
  );
};
export default AuthTabs;
